/**
 * Florastory 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const florastoryPaymentConfig: BrandPaymentConfig = {
  brand: 'florastory',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/florastory/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/florastory/vip_bg.webp',
      memberSubscribeBg: '/images/florastory/member_subscribe_bg.webp',
      vipIcon: '/images/florastory/vip_icon2.png',
      vipDiscountIcon: '/images/florastory/vip_discount.png',
      discountBg: '/images/florastory/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: 'linear-gradient(90deg, #13B866 0.03%, #8DDC6C 100%)',
      purpleTextGradient: 'linear-gradient(180deg, #BDEFCF 0%, #DFF7E8 70%, #F4FFF8 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
    },
  },

  // 阅读器弹窗配置
  chapter: {
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #13B866, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#21A967',
      coinsPopupText3: '#65686F',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#EAF8F0',
      subscribeActiveBg: '#F3F5FA',
      purpleTextGradient: 'linear-gradient(180deg, #BDEFCF 0%, #DFF7E8 70%, #F4FFF8 100%)',
      pinkGradient: 'linear-gradient(90deg, #13B866 0.03%, #8DDC6C 100%)',
      memberSubscribeBg: '/images/florastory/chapter/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
